import { authService } from './../../shared/services/auth.service';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import LanguageSelector from '../language-selector/language-selector.component.vue';
import publicLayoutModule from '@/store/modules/public-layout.module';

@Component({
  components: {
    LanguageSelector,
  },
})
export default class PublicHeaderComponent extends Vue {
  @Prop() public title!: string;
  public isLogged: boolean = false;

  public async isLoggedin() {
    let user = await authService.getUser();
    let res = authService.username != null && !user?.expired; //
    let userna = authService.username;
    let exp = user?.expired;
    let expAt = user?.expires_at;
    let expIn = user?.expires_in;
    if(!res)
      authService.logoutWithoutRedirect();
    this.isLogged = res;
  }
  public async mounted() {
    await this.isLoggedin();
  }
  public async created() {
    await this.isLoggedin();
    publicLayoutModule.setWebTab(this.$route.path.toString());
  }

  public closeMenu() {
    let menu = document.getElementById('navbarSupportedContent');
    let menuButton = document.getElementById('menuButton');
    menu?.classList.remove('show');
    menuButton?.classList.remove('active');
    menuButton?.classList.add('collapsed');
  }

  public goTo(path: string) {
    this.closeMenu();
    this.$router.push(path).catch(err => { });
    publicLayoutModule.setWebTab(path);
  }

  public get webTab() {
    return publicLayoutModule.webTab;
  }

  public get urlCasos() {
    return "/casos";
  }

  public get logText() {
    if (authService.username == null)
      return 'Login';
    return 'Logout';
  }

  public logout() {
    authService.logout();
    this.goTo('/inicio');
  }

  public login() {
    if (this.isLogged)
      authService.logout();
    this.goTo('/login');
  }

  public private() {
    if (this.isLogged) {
      this.goTo('/home/main');
    }
  }

}